import {AppConstants} from '../../utils/constants';

export class CustomerFilterModel {
  paginationCriteria?: PaginationCriteria;
  searchKeyword?: string;
  sortCriteria?: SortCriteria;
  filterCriteria?: FilterCriteria;

  constructor() {
    this.paginationCriteria = new PaginationCriteria();
    this.sortCriteria = new SortCriteria();
    this.filterCriteria = new FilterCriteria();
    this.searchKeyword = "";
  }
}

export class PaginationCriteria {
  offset: number;
  itemsPerPage: number;

  constructor(offset = 0, itemsPerPage = 10) {
    this.offset = offset;
    this.itemsPerPage = itemsPerPage;
  }
}

export class SortCriteria {
  field: string;
  direction: string;

  constructor(field = AppConstants.sortCompanyField, direction = 'ASC') {
    this.field = field;
    this.direction = direction;
  }
}

export class FilterCriteria {
  targetGroupValue: any;
  active: boolean;
  confirmed: boolean;
  countryCode: string;

  constructor(targetGroupValue = null, active = null, confirmed = null, countryCode = null) {
    this.targetGroupValue = targetGroupValue;
    this.active = active;
    this.confirmed = confirmed;
    this.countryCode = countryCode;
  }
}
